class UserClientsTableController {
  public clients: any[];
  public allocatedClients: any[];

  public searchText: string;

  constructor() { }

  clearSearchTerm() {
    this.searchText = '';
  }

  removeClient(clientNumber: string) {
    this.allocatedClients = this.allocatedClients.filter(c => c.clientNumber !== clientNumber);
  }
}

export const UserClientsTable: angular.IComponentOptions = {
  controller: UserClientsTableController,
  template: require('./userClientsTable.component.html'),
  bindings: {
    clients: '<',
    allocatedClients: '='
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/userClientsTable.component.ts